import { createSlice } from "@reduxjs/toolkit";
import { User } from "../../@types/user";
import { createUser } from "./actions/createUser";
interface UserCreateState {
  user: User;
  createStatus: string;
}

const initialState = {
  user: {},
  createStatus: "",
} as UserCreateState;

const userCreateSlice = createSlice({
  name: "userCreate",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createUser.pending, (state, { payload }) => {
        state.createStatus = "pending";
      })
      .addCase(createUser.fulfilled, (state, { payload }) => {
        state.createStatus = "fulfilled";
      })
      .addCase(createUser.rejected, (state, { payload }) => {
        state.createStatus = "rejected";
      });
  },
});

export default userCreateSlice.reducer;
